import { __decorate } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Widget } from "@shop-builder/core/widget";
import PropTypes from "@shop-builder/core/prop-types";
import { findAll } from "@api/services/products";
import { findOneByComponentSet } from "@api/services/offers";
import { Configurator } from "@api/services/configurator";
import { getQueryParams } from "@api/utils";
import { TrackingDeviceFilter } from "@api/services/tracking";
import { findOneById } from "../../../api/services/tariff";
var KissDevicesWidget = /*@__PURE__*/ (function () {
    function KissDevicesWidget() {
        this.ALL_DEVICES = "none";
        this.selectedManufacturer = this.ALL_DEVICES;
        this.manufacturers = [];
        this.numberOfDevicesFromManufacturer = [];
        this.devicesInFlux = [];
        this.xOfyDevices = "<strong> x von y Geräten</strong>";
        this.maxNumberVisible = 0;
        this.LOAD_MORE_DEVICES = 6;
        this.subTariffIds = new Map();
        this.allAvailableDevices = [];
    }
    KissDevicesWidget_1 = KissDevicesWidget;
    KissDevicesWidget.prototype.didMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, m, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setUpAllManufacturerClick();
                        params = getQueryParams(document.location.search);
                        if (params.m) {
                            m = params.m.toLowerCase();
                            if (document.querySelector("#" + m)) {
                                this.selectedManufacturer = m;
                                this.selectManufacturer();
                            }
                        }
                        // get flux
                        _a = this;
                        return [4 /*yield*/, findAll()];
                    case 1:
                        // get flux
                        _a.devicesInFlux = _b.sent();
                        // get Manufacturers from devices
                        this.setUpAvailableManufacturerSet();
                        // get all device ids
                        this.allAvailableDevices = this.getAllDevices();
                        this.allAvailableDevices = this.syncDevices(this.allAvailableDevices, this.devicesInFlux);
                        // set up initial View
                        this.initialSetUpView();
                        // add Event Listener
                        Configurator.subscribe("offerChanged", this.onOfferChanged.bind(this));
                        Configurator.subscribe("subTariffIdsSet", function (subTariffIds) {
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.subTariffIds = subTariffIds;
                                            return [4 /*yield*/, this.onOfferChanged()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        return [4 /*yield*/, this.onOfferChanged()];
                    case 2:
                        _b.sent();
                        KissDevicesWidget_1.checkForManufacturerFilterHeight();
                        jQuery(window).on("vf::resize", function () {
                            KissDevicesWidget_1.checkForManufacturerFilterHeight();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    KissDevicesWidget.prototype.onOfferChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tariff, tariffLabels, subTariff, _a, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        tariff = Configurator.getTariff();
                        if (!!tariff)
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        tariffLabels = Array.prototype.slice.call(document.querySelectorAll(".mod-ep-kiss-devices__tariff-name"));
                        return [4 /*yield*/, tariffLabels.forEach(function (label) { return (label.innerText = tariff.label); })];
                    case 3:
                        _c.sent();
                        subTariff = null;
                        if (!this.subTariffIds.has(Configurator.getTariff().id))
                            return [3 /*break*/, 5];
                        return [4 /*yield*/, findOneById(this.subTariffIds.get(Configurator.getTariff().id))];
                    case 4:
                        subTariff = _c.sent();
                        _c.label = 5;
                    case 5:
                        _b = (_a = this.allAvailableDevices).forEach;
                        return [4 /*yield*/, (function (device) {
                                return __awaiter(_this, void 0, void 0, function () {
                                    var product, offer, error_1, deviceEl, price, priceboxEl, priceStr, euro, cents;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                product = this.devicesInFlux[device.indexFlux];
                                                if (!subTariff)
                                                    return [3 /*break*/, 6];
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([1, 3, , 5]);
                                                return [4 /*yield*/, findOneByComponentSet([
                                                        product,
                                                        subTariff,
                                                    ])];
                                            case 2:
                                                offer = _a.sent();
                                                return [3 /*break*/, 5];
                                            case 3:
                                                error_1 = _a.sent();
                                                return [4 /*yield*/, findOneByComponentSet([
                                                        product,
                                                        Configurator.getTariff(),
                                                    ])];
                                            case 4:
                                                offer = _a.sent();
                                                return [3 /*break*/, 5];
                                            case 5: return [3 /*break*/, 8];
                                            case 6: return [4 /*yield*/, findOneByComponentSet([
                                                    product,
                                                    Configurator.getTariff(),
                                                ])];
                                            case 7:
                                                offer = _a.sent();
                                                _a.label = 8;
                                            case 8:
                                                deviceEl = document.getElementById(device.divId);
                                                price = offer.getOnetimePrice();
                                                priceboxEl = deviceEl.querySelector(".mod-ep-kiss-devices__pricebox");
                                                (price <= 1 && priceboxEl.classList.add("red")) ||
                                                    (price > 1 && priceboxEl.classList.remove("red"));
                                                priceStr = (price + "").split(".");
                                                euro = priceStr[0];
                                                cents = (!priceStr[1] && "00") ||
                                                    (priceStr[1] &&
                                                        priceStr[1].length < 2 &&
                                                        priceStr[1] + "0") ||
                                                    priceStr[1];
                                                deviceEl.querySelector(".mod-ep-kiss-devices__price-euro").innerHTML = euro;
                                                deviceEl.querySelector(".mod-ep-kiss-devices__price-cent").innerHTML = cents;
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            })];
                    case 6:
                        _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/];
                }
            });
        });
    };
    KissDevicesWidget.prototype.initialSetUpView = function () {
        var _this = this;
        this.allAvailableDevices.forEach(function (avDev) {
            return _this.setUpDeviceItem(avDev);
        });
        this.setUpManufacturerSelectionOnClick();
        this.setUpLoadMoreAllOnClick();
        this.loadMore();
        document
            .getElementsByClassName("mod-ep-kiss-devices__devices")[0]
            .classList.add("loaded");
        document
            .getElementsByClassName("mod-ep-kiss-devices__manufacturer-selection-list")[0]
            .classList.add("loaded");
    };
    KissDevicesWidget.prototype.setUpAvailableManufacturerSet = function () {
        var _this = this;
        var counter = 0;
        Array.prototype.slice
            .call(document.querySelectorAll(".mod-ep-kiss-devices__manufacturer a"))
            .forEach(function (el) {
            _this.manufacturers[el.dataset.manufacturer] = counter++;
            _this.numberOfDevicesFromManufacturer[el.dataset.manufacturer] = 0;
        });
        this.manufacturers[this.ALL_DEVICES] = counter;
    };
    KissDevicesWidget.prototype.syncDevices = function (availableDevices, devicesInFlux) {
        var _this = this;
        availableDevices = availableDevices.filter(function (device) {
            var indexFlux = _this.getIndexInFlux(device.id);
            var available = indexFlux > -1;
            var element = (document.querySelector("#" + device.divId));
            if (available) {
                device.manufacturer =
                    _this.manufacturers[element.dataset.manufacturer];
                device.image =
                    "//eweb8.vfd2-testnet.de" +
                        devicesInFlux[indexFlux].getImages().small;
                device.indexFlux = indexFlux;
                _this.numberOfDevicesFromManufacturer[element.dataset.manufacturer] = _this.numberOfDevicesFromManufacturer[element.dataset.manufacturer]
                    ? _this.numberOfDevicesFromManufacturer[element.dataset.manufacturer] + 1
                    : 1;
            }
            else {
                // hide and delete from availableDevices
                element.style.display = "none";
            }
            return available;
        });
        this.manufacturers.forEach(function (manufacturer) {
            return (_this.numberOfDevicesFromManufacturer[manufacturer] =
                !_this.numberOfDevicesFromManufacturer[manufacturer] && 0);
        });
        this.numberOfDevicesFromManufacturer[this.ALL_DEVICES] =
            availableDevices.length;
        return availableDevices;
    };
    KissDevicesWidget.prototype.getAllDevices = function () {
        var _this = this;
        var devices = Array.prototype.slice.call(document.querySelectorAll(".mod-ep-kiss-devices__device-item"));
        var devicesObj = [];
        devices.forEach(function (deviceEl) {
            var deviceId = parseInt(deviceEl.dataset.deviceId);
            devicesObj.push({
                id: deviceId,
                divId: deviceEl.id,
                visible: false,
                manufacturer: _this.manufacturers[deviceEl.dataset.manufacturer],
            });
        });
        return devicesObj;
    };
    KissDevicesWidget.prototype.getIndexInFlux = function (deviceId) {
        return (this.devicesInFlux &&
            this.devicesInFlux.findIndex(function (deviceFlux) { return deviceId === deviceFlux.id; }));
    };
    KissDevicesWidget.prototype.setUpDeviceItem = function (device) {
        var element = document.querySelector("#" + device.divId);
        var img = (element.getElementsByClassName("mod-ep-kiss-devices__device-image-wrapper")[0].children[0]);
        img.src = device.image;
        img.dataset.src = device.image;
    };
    KissDevicesWidget.prototype.setUpManufacturerSelectionOnClick = function () {
        var _this = this;
        var manufacturer = Array.prototype.slice.call(document.querySelectorAll(".mod-ep-kiss-devices__manufacturer a"));
        manufacturer.forEach(function (mfr) {
            mfr.addEventListener("click", function () {
                return _this.handleManufacturerChanged(mfr);
            });
        });
    };
    KissDevicesWidget.prototype.setUpLoadMoreAllOnClick = function () {
        var _this = this;
        var loadMoreBtn = document.getElementsByClassName("mod-ep-kiss-devices__more-devices")[0];
        var loadAllLnk = document.getElementsByClassName("mod-ep-kiss-devices__all-devices")[0];
        loadAllLnk.addEventListener("click", function () { return _this.loadAll(); });
        loadMoreBtn.addEventListener("click", function () { return _this.loadMore(); });
    };
    KissDevicesWidget.prototype.handleManufacturerChanged = function (mfrEl) {
        return __awaiter(this, void 0, void 0, function () {
            var manufacturer, addManufacturerFilter;
            return __generator(this, function (_a) {
                manufacturer = mfrEl.getAttribute("data-manufacturer");
                addManufacturerFilter = this.selectedManufacturer !== manufacturer;
                this.selectedManufacturer = addManufacturerFilter
                    ? manufacturer
                    : this.ALL_DEVICES;
                // reset to default
                this.maxNumberVisible = Math.min.apply(Math, [
                    this.LOAD_MORE_DEVICES,
                    this.numberOfDevicesFromManufacturer[this.selectedManufacturer],
                ]);
                this.trackingFilterEvent(addManufacturerFilter, manufacturer);
                this.updateDevices();
                this.updateManufacturers();
                return [2 /*return*/];
            });
        });
    };
    KissDevicesWidget.prototype.loadMore = function () {
        this.maxNumberVisible = Math.min.apply(Math, [
            this.maxNumberVisible + this.LOAD_MORE_DEVICES,
            this.numberOfDevicesFromManufacturer[this.selectedManufacturer],
        ]);
        this.updateDevices();
    };
    KissDevicesWidget.prototype.loadAll = function () {
        this.maxNumberVisible =
            this.numberOfDevicesFromManufacturer[this.selectedManufacturer];
        this.loadMore();
    };
    KissDevicesWidget.prototype.updateManufacturers = function () {
        this.deselectManufacturers();
        if (this.selectedManufacturer != this.ALL_DEVICES) {
            this.selectManufacturer();
        }
    };
    KissDevicesWidget.prototype.selectManufacturer = function () {
        var manufacturerList = document.querySelector(".mod-ep-kiss-devices__manufacturer-selection ul");
        manufacturerList.classList.add("filtered");
        var manufacturerSelectedEl = document.querySelector("#" + this.selectedManufacturer);
        manufacturerSelectedEl.classList.add("selected");
        if (jQuery(manufacturerSelectedEl).is(":hidden")) {
            jQuery(".mod-ep-kiss-devices__more-manufacturer").trigger("click");
        }
    };
    KissDevicesWidget.prototype.deselectManufacturers = function () {
        var manufacturerList = document.querySelector(".mod-ep-kiss-devices__manufacturer-selection ul");
        manufacturerList.classList.remove("filtered");
        var manufacturerSelection = Array.prototype.slice.call(document.querySelectorAll(".mod-ep-kiss-devices__manufacturer a"));
        manufacturerSelection.forEach(function (mfrEl) {
            mfrEl.classList.remove("selected");
        });
    };
    KissDevicesWidget.prototype.updateDevices = function () {
        var _this = this;
        var counter = 0;
        this.allAvailableDevices.forEach(function (device) {
            device.visible =
                (device.manufacturer ===
                    _this.manufacturers[_this.selectedManufacturer] ||
                    _this.selectedManufacturer == _this.ALL_DEVICES) &&
                    counter < _this.maxNumberVisible;
            device.visible && counter++;
        });
        this.updateDevicesVisible(this.maxNumberVisible ===
            this.numberOfDevicesFromManufacturer[this.selectedManufacturer]);
    };
    KissDevicesWidget.prototype.updateDevicesVisible = function (hideLoadMoreBtn) {
        var _this = this;
        var amountDevicesTxt = document.getElementsByClassName("mod-ep-kiss-devices__device-count")[0];
        amountDevicesTxt.innerHTML = this.xOfyDevices
            .replace("x", this.maxNumberVisible + "")
            .replace("y", this.numberOfDevicesFromManufacturer[this.selectedManufacturer] + "");
        this.allAvailableDevices.forEach(function (device) {
            (device.visible && _this.showDevice(device.divId)) ||
                (!device.visible && _this.hideDevice(device.divId));
        });
        (document.querySelector(".mod-ep-kiss-devices__load-more")).style.visibility = hideLoadMoreBtn ? "hidden" : "visible";
        (document.querySelector(".mod-ep-kiss-devices__all-devices")).style.visibility = hideLoadMoreBtn ? "hidden" : "visible";
    };
    KissDevicesWidget.prototype.showDevice = function (selector) {
        var element = document.querySelector("#" + selector);
        element.classList.add("active");
        element.classList.remove("inactive");
    };
    KissDevicesWidget.prototype.hideDevice = function (selector) {
        var element = document.querySelector("#" + selector);
        element.classList.remove("active");
        element.classList.add("inactive");
    };
    KissDevicesWidget.prototype.trackingFilterEvent = function (addManufacturerFilter, manufacturer) {
        var filterTracking = new TrackingDeviceFilter();
        var action = "";
        var trackingManufacturer = null;
        if (addManufacturerFilter) {
            trackingManufacturer = {
                name: "vendor",
                value: manufacturer[0].toLocaleUpperCase() +
                    manufacturer.slice(1, manufacturer.length),
            };
            action = "add filter";
        }
        else {
            trackingManufacturer = null;
            action = "remove filter";
        }
        var updatedFilter = trackingManufacturer || [];
        var appliedFilter = (trackingManufacturer && [trackingManufacturer]) || [];
        filterTracking
            .setAction(action)
            .setUpdatedFilter(updatedFilter)
            .setAppliedFilters(appliedFilter)
            .track()
            .then();
    };
    KissDevicesWidget.prototype.setUpAllManufacturerClick = function () {
        jQuery(".mod-ep-kiss-devices__more-manufacturer").on("click", function () {
            jQuery(".mod-ep-kiss-devices__manufacturer-selection ul").addClass("showAllManufacturer");
            KissDevicesWidget_1.checkForManufacturerFilterHeight();
            jQuery(".mod-ep-kiss-devices__more-manufacturer")
                .parent("div")
                .hide();
        });
    };
    KissDevicesWidget.checkForManufacturerFilterHeight = function () {
        if (jQuery(".mod-ep-kiss-devices__manufacturer-selection ul").outerHeight() ==
            jQuery(".mod-ep-kiss-devices__manufacturer").outerHeight(true)) {
            jQuery(".mod-ep-kiss-devices__manufacturer-selection ul").removeClass("leftAligned");
        }
        else {
            jQuery(".mod-ep-kiss-devices__manufacturer-selection ul").addClass("leftAligned");
        }
        if (jQuery(".mod-ep-kiss-devices__manufacturer-selection ul li")
            .length <= 6) {
            jQuery(".mod-ep-kiss-devices__more-manufacturer").remove();
        }
        else {
            jQuery(".mod-ep-kiss-devices__more-manufacturer").show();
        }
    };
    var KissDevicesWidget_1;
    KissDevicesWidget.propTypes = {
        devicelistingurl: PropTypes.String,
    };
    KissDevicesWidget = KissDevicesWidget_1 = __decorate([
        Widget({
            name: "kiss-devices",
        })
    ], KissDevicesWidget);
    return KissDevicesWidget;
}());
export { KissDevicesWidget };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/kiss-devices/kiss-devices.ts
// module id = null
// module chunks = 